import { motion } from "framer-motion";

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-6"
      >
        <div className="font-mono-tech text-xs sm:text-sm tracking-[0.25em] text-[#D4AF37] mb-4" dir="ltr">— ABOUT BARAH</div>
        <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl leading-snug text-[#F8FAFC]" data-testid="about-title">
          براح الرقمية… <span className="gold-text">نمتلك وندير منصات رقمية حيّة</span>
        </h2>
        <p className="mt-6 font-body text-base sm:text-lg leading-relaxed text-[#94A3B8]" data-testid="about-text">
          «براح» في اللغة: الفضاء الواسع المنبسط — وهذا ما نصنعه لك: مساحة رقمية تتسع لطموحك.
          نحن مكتب سعودي متخصص في الاتصالات وتقنية المعلومات، لا نكتفي بتقديم الاستشارات أو التصاميم،
          بل نبني ونطلق وندير منصات رقمية حيّة تعمل بالفعل وتُدرّ دخلاً —
          من الفكرة، إلى المتطلبات، إلى التطوير بالذكاء الاصطناعي، إلى الإطلاق والتشغيل.
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { t: "رؤيتنا", d: "أن نكون البراح الأول لبناء وتشغيل المنصات الرقمية الذكية في المملكة." },
            { t: "رسالتنا", d: "نحوّل الأفكار إلى منصات حيّة تعمل بجودة مؤسسية وسرعة استثنائية." },
          ].map((v) => (
            <div key={v.t} className="glass-card rounded-2xl p-5" data-testid={`about-${v.t === "رؤيتنا" ? "vision" : "mission"}`}>
              <div className="font-display font-bold text-[#E5C158] text-lg">{v.t}</div>
              <div className="mt-2 text-sm leading-relaxed text-[#94A3B8] font-body">{v.d}</div>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="lg:col-span-6 relative"
      >
        <div className="relative rounded-3xl overflow-hidden border border-[#D4AF37]/25" data-testid="about-image-frame">
          <img
            src="https://images.unsplash.com/photo-1663900108404-a05e8bf82cda?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxyaXlhZGglMjBza3lsaW5lJTIwbmlnaHQlMjBhcmNoaXRlY3R1cmUlMjBsdXh1cnl8ZW58MHx8fHwxNzkzNzU3OTk1fDA&ixlib=rb-4.1.0&q=85"
            alt="أفق الرياض ليلاً"
            className="w-full h-[420px] sm:h-[520px] object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#060B19] via-transparent to-transparent" />
          <div className="absolute bottom-5 right-5 left-5 glass-card rounded-2xl px-5 py-4">
            <div className="font-display font-bold text-[#F8FAFC]">من قلب المملكة العربية السعودية</div>
            <div className="text-sm text-[#94A3B8] font-body mt-1">نخدم المنشآت الصغيرة والمتوسطة والقطاع المالي والمؤسسي</div>
          </div>
        </div>
        <div className="absolute -top-6 -left-4 sm:-left-8 glass-card rounded-2xl px-6 py-4 float-slow" data-testid="about-domain-badge">
          <div className="font-mono-tech text-sm text-[#E5C158]" dir="ltr">brah-tech.com</div>
          <div className="text-xs text-[#94A3B8] mt-1">نطاقنا الرسمي</div>
        </div>
      </motion.div>
    </div>
  </section>
);
